var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shareButton"},[_c('div',{staticClass:"textLabel"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":'/share/'+_vm.icon+'.png'}})])])}
var staticRenderFns = []

export { render, staticRenderFns }